import {
    USER_ITEM_REQUEST,
    USER_ITEM_RESPONSE,
    USER_ITEM_CACHED_RESPONSE,
    USER_ITEM_SAVE_REQUEST,
    USER_ITEM_SAVE_RESPONSE,
    USERS_PAGE_LIST_REQUEST,
    USERS_PAGE_LIST_RESPONSE,
    USER_LIST_REQUEST,
    USER_LIST_SEARCH_REQUEST,
    USER_LIST_RESPONSE,
    USER_LIST_CACHED_RESPONSE,
    USER_LIST_ERROR_RESPONSE,
    USER_APPLY_FILTER_CRITERIA,
    USER_APPLY_MODEL_UPDATE,
    USER_CANCEL_MODEL_UPDATE
} from "../actions/action-types"
import { defaultSearchCriteria } from "../reducers/paging/user-paging-reducer"
import {
    getUserList,
    getUserItem,
    putUserItem,
    postUserItem
} from "../api/user-api"
import {
    hydrate as hydrateUser,
    normalisingFields
} from "../models/entities/user"
import {
    requestListEpic,
    requestListSearchEpic,
    requestListFilterEpic,
    requestItemEpic,
    requestItemSaveEpic,
    requestTopItemFromListResponseEpic,
    callbackActionCreatorEpic,
    syncIdToURLEpic
} from "./default-epics/default-entity-epics"
import {
    usersPageListRequest,
    userListResponse,
    userListRequest,
    userListCachedResponse,
    userListErrorResponse,
    userItemRequest,
    userItemResponse,
    userItemCachedResponse,
    userItemErrorResponse,
    userItemSaveRequest,
    userItemSaveResponse
} from "../actions/user-actions" 

export const requestUserListEpic = requestListEpic(
    USER_LIST_REQUEST,
    getUserList,
    "users",
    userListResponse,
    userListCachedResponse,
    userListErrorResponse
)

export const requestUserListPageEpic = action$ =>
    action$
        .ofType(USERS_PAGE_LIST_REQUEST)
        .map(({ type, ...pagingRequest }) => userListRequest(pagingRequest))

export const requestUserSearchEpic = requestListSearchEpic(
    USER_LIST_SEARCH_REQUEST,
    usersPageListRequest,
    "users"
)

export const applyUserFilterCriteria = requestListFilterEpic(
    USER_APPLY_FILTER_CRITERIA,
    usersPageListRequest,
    "users"
)

export const requestUserItemEpic = requestItemEpic(
    USER_ITEM_REQUEST,
    getUserItem,
    "users",
    hydrateUser,
    normalisingFields,
    userItemResponse,
    userItemCachedResponse,
    userItemErrorResponse
)

export const requestUserCancelModelUpdateEpic = (action$, { getState }) =>
    action$
        .ofType(USER_CANCEL_MODEL_UPDATE)
        .map(() => getState().presentation.users.activeId)
        .filter(id => id)
        .map(userItemRequest)

export const requestUserApplyModelUpdateEpic = (action$, { getState }) =>
    action$.ofType(USER_APPLY_MODEL_UPDATE).map(() => {
        const {
            activeId,
            updateModel,
            imageToUpload
        } = getState().presentation.users
        let newUpdateModel = activeId
            ? updateModel.set("id", activeId)
            : updateModel
        return userItemSaveRequest(
            activeId,
            newUpdateModel.toJS(),
            imageToUpload
        )
    })

export const requestUserItemSaveEpic = requestItemSaveEpic(
    USER_ITEM_SAVE_REQUEST,
    putUserItem,
    postUserItem,
    "user",
    userItemSaveResponse,
    userItemErrorResponse
)

export const responseUserListEpic = requestTopItemFromListResponseEpic(
    USERS_PAGE_LIST_RESPONSE,
    userItemRequest,
    "users",
    "users",
    defaultSearchCriteria
)

export const responseUserCallbackEpic = callbackActionCreatorEpic(
    USER_LIST_RESPONSE,
    USER_LIST_CACHED_RESPONSE,
    USER_LIST_ERROR_RESPONSE
)

export const syncUserIdToURLEpic = syncIdToURLEpic(
    "users",
    USER_ITEM_RESPONSE,
    USER_ITEM_SAVE_RESPONSE,
    USER_ITEM_CACHED_RESPONSE
)
